let typesOfRooms = ["water", "normal"];

export function randomTypeOfRoom() {
  let randomIndex = Math.floor(Math.random() * typesOfRooms.length);
  return typesOfRooms[randomIndex];
}

export function randomNameOfRoom(roomType) {
  if (roomType === "water") {
    let waterRooms = [
      "The Abarat",
      "Absolom",
      "Zandia",
      "Warbler",
      "Wedge Island",
      "Seal Island",
      "Scheria",
      "Nowhere Island",
      "Odo Island",
      "Oxbay",
      "Kalmidoor",
      "Kokomo",
      "Fibber Island",
      "Gaea",
      "Back Cup",
      "Beer Island",
      "Candy Apple Island",
      "Clanbronwyn",
      "Coral Island"
    ];
    let roomIndex = Math.floor(Math.random() * waterRooms.length);
    return waterRooms[roomIndex];
  } else if (roomType === "normal") {
    let normalRooms = [
      "Barnenez",
      "Tumulus of Bougon",
      "Knap of Howar",
      "Dolmen of Menga",
      "West Kennet Long Barrow",
      "The Kitchen",
      "Newgrange",
      "Skara Brae",
      "Tomb of the Eagles",
      "Tepe Sialk",
      "Dolmen de Bagneux",
      "Maeshowe",
      "Harappa",
      "Dholavira",
      "Quoyness Cairn"
    ];
    let roomIndex = Math.floor(Math.random() * normalRooms.length);
    return normalRooms[roomIndex];
  }
}

//You <sense> a <adj> <noun>. You feel <adj>.
let senses = ["hear", "see", "taste", "feel", "smell"];
let adjectives = [
  "aback",
  "abaft",
  "abandoned",
  "abashed",
  "aberrant",
  "abhorrent",
  "abiding",
  "abject",
  "ablaze",
  "able",
  "abnormal",
  "aboard",
  "aboriginal",
  "abortive",
  "abounding",
  "abrasive",
  "abrupt",
  "absent",
  "absorbed",
  "absorbing",
  "abstracted",
  "absurd",
  "abundant",
  "abusive",
  "acceptable",
  "accessible",
  "accidental",
  "accurate",
  "acid",
  "acidic",
  "acoustic",
  "acrid",
  "actually",
  "ad",
  "hoc",
  "adamant",
  "adaptable",
  "addicted",
  "adhesive",
  "adjoining",
  "adorable",
  "adventurous",
  "afraid",
  "aggressive",
  "agonizing",
  "agreeable",
  "ahead",
  "ajar",
  "alcoholic",
  "alert",
  "alike",
  "alive",
  "alleged",
  "alluring",
  "aloof",
  "amazing",
  "ambiguous",
  "ambitious",
  "amuck",
  "amused",
  "amusing",
  "ancient",
  "angry",
  "animated",
  "annoyed",
  "annoying",
  "anxious",
  "apathetic",
  "aquatic",
  "aromatic",
  "arrogant",
  "ashamed",
  "aspiring",
  "assorted",
  "astonishing",
  "attractive",
  "auspicious",
  "automatic",
  "available",
  "average",
  "awake",
  "aware",
  "awesome",
  "awful",
  "axiomatic",
  "bad",
  "barbarous",
  "bashful",
  "bawdy",
  "beautiful",
  "befitting",
  "belligerent",
  "beneficial",
  "bent",
  "berserk",
  "best",
  "better",
  "bewildered",
  "big",
  "billowy",
  "bite-sized",
  "bitter",
  "bizarre",
  "black",
  "black-and-white",
  "bloody",
  "blue",
  "blue-eyed",
  "blushing",
  "boiling",
  "boorish",
  "bored",
  "boring",
  "bouncy",
  "boundless",
  "brainy",
  "brash",
  "brave",
  "brawny",
  "breakable",
  "breezy",
  "brief",
  "bright",
  "bright",
  "broad",
  "broken",
  "brown",
  "bumpy",
  "burly",
  "bustling",
  "busy",
  "cagey",
  "calculating",
  "callous",
  "calm",
  "capable",
  "capricious",
  "careful",
  "careless",
  "caring",
  "cautious",
  "ceaseless",
  "certain",
  "changeable",
  "charming",
  "cheap",
  "cheerful",
  "chemical",
  "chief",
  "childlike",
  "chilly",
  "chivalrous",
  "chubby",
  "chunky",
  "clammy",
  "classy",
  "clean",
  "clear",
  "clever",
  "cloistered",
  "cloudy",
  "closed",
  "clumsy",
  "cluttered",
  "coherent",
  "cold",
  "colorful",
  "colossal",
  "combative",
  "comfortable",
  "common",
  "complete",
  "complex",
  "concerned",
  "condemned",
  "confused",
  "conscious",
  "cooing",
  "cool",
  "cooperative",
  "coordinated",
  "courageous",
  "cowardly",
  "crabby",
  "craven",
  "crazy",
  "creepy",
  "crooked",
  "crowded",
  "cruel",
  "cuddly",
  "cultured",
  "cumbersome",
  "curious",
  "curly",
  "curved",
  "curvy",
  "cut",
  "cute",
  "cute",
  "cynical",
  "daffy",
  "daily",
  "damaged",
  "damaging",
  "damp",
  "dangerous",
  "dapper",
  "dark",
  "dashing",
  "dazzling",
  "dead",
  "deadpan",
  "deafening",
  "dear",
  "debonair",
  "decisive",
  "decorous",
  "deep",
  "deeply",
  "defeated",
  "defective",
  "defiant",
  "delicate",
  "delicious",
  "delightful",
  "demonic",
  "delirious",
  "dependent",
  "depressed",
  "deranged",
  "descriptive",
  "deserted",
  "detailed",
  "determined",
  "devilish",
  "didactic",
  "different",
  "difficult",
  "diligent",
  "direful",
  "dirty",
  "disagreeable",
  "disastrous",
  "discreet",
  "disgusted",
  "disgusting",
  "disillusioned",
  "dispensable",
  "distinct",
  "disturbed",
  "divergent",
  "dizzy",
  "domineering",
  "doubtful",
  "drab",
  "draconian",
  "dramatic",
  "dreary",
  "drunk",
  "dry",
  "dull",
  "dusty",
  "dynamic",
  "dysfunctional",
  "eager",
  "early",
  "earsplitting",
  "earthy",
  "easy",
  "eatable",
  "economic",
  "educated",
  "efficacious",
  "efficient",
  "eight",
  "elastic",
  "elated",
  "elderly",
  "electric",
  "elegant",
  "elfin",
  "elite",
  "embarrassed",
  "eminent",
  "empty",
  "enchanted",
  "enchanting",
  "encouraging",
  "endurable",
  "energetic",
  "enormous",
  "entertaining",
  "enthusiastic",
  "envious",
  "equable",
  "equal",
  "erect",
  "erratic",
  "ethereal",
  "evanescent",
  "evasive",
  "even excellent excited",
  "exciting exclusive",
  "exotic",
  "expensive",
  "extra-large extra-small exuberant",
  "exultant",
  "fabulous",
  "faded",
  "faint fair",
  "faithful",
  "fallacious",
  "false familiar famous",
  "fanatical",
  "fancy",
  "fantastic",
  "far",
  " far-flung",
  " fascinated",
  "fast",
  "fat faulty",
  "fearful fearless",
  "feeble feigned",
  "female fertile",
  "festive",
  "few fierce",
  "filthy",
  "fine",
  "finicky",
  "first",
  " five",
  " fixed",
  " flagrant",
  "flaky",
  "flashy",
  "flat",
  "flawless",
  "flimsy",
  " flippant",
  "flowery",
  "fluffy",
  "fluttering",
  " foamy",
  "foolish",
  "foregoing",
  "forgetful",
  "fortunate",
  "four frail",
  "fragile",
  "frantic",
  "free",
  " freezing",
  " frequent",
  " fresh",
  " fretful",
  "friendly",
  "frightened frightening full fumbling functional",
  "funny",
  "furry furtive",
  "future futuristic",
  "fuzzy ",
  "gabby",
  "gainful",
  "gamy",
  "gaping",
  "garrulous",
  "gaudy",
  "general gentle",
  "giant",
  "giddy",
  "gifted",
  "gigantic",
  "glamorous",
  "gleaming",
  "glib",
  "glistening glorious",
  "glossy",
  "godly",
  "good",
  "goofy",
  "gorgeous",
  "graceful",
  "grandiose",
  "grateful gratis",
  "gray greasy great",
  "greedy",
  "green grey grieving",
  "groovy",
  "grotesque",
  "grouchy",
  "grubby gruesome",
  "grumpy",
  "guarded",
  "guiltless",
  "gullible gusty",
  "guttural H habitual",
  "half",
  "hallowed",
  "halting",
  "handsome",
  "handsomely",
  "handy",
  "hanging",
  "hapless",
  "happy",
  "hard",
  "hard-to-find",
  "harmonious",
  "harsh",
  "hateful",
  "heady",
  "healthy",
  "heartbreaking",
  "heavenly heavy hellish",
  "helpful",
  "helpless",
  "hesitant",
  "hideous high",
  "highfalutin",
  "high-pitched",
  "hilarious",
  "hissing",
  "historical",
  "holistic",
  "hollow",
  "homeless",
  "homely",
  "honorable",
  "horrible",
  "hospitable",
  "hot huge",
  "hulking",
  "humdrum",
  "humorous",
  "hungry",
  "hurried",
  "hurt",
  "hushed",
  "husky",
  "hypnotic",
  "hysterical",
  "icky",
  "icy",
  "idiotic",
  "ignorant",
  "ill",
  "illegal",
  "ill-fated",
  "ill-informed",
  "illustrious",
  "imaginary",
  "immense",
  "imminent",
  "impartial",
  "imperfect",
  "impolite",
  "important",
  "imported",
  "impossible",
  "incandescent",
  "incompetent",
  "inconclusive",
  "industrious",
  "incredible",
  "inexpensive",
  "infamous",
  "innate",
  "innocent",
  "inquisitive",
  "insidious",
  "instinctive",
  "intelligent",
  "interesting",
  "internal",
  "invincible",
  "irate",
  "irritating",
  "itchy",
  "jaded",
  "jagged",
  "jazzy",
  "jealous",
  "jittery",
  "jobless",
  "jolly",
  "joyous",
  "judicious",
  "juicy",
  "jumbled",
  "jumpy",
  "juvenile",
  "kaput",
  "keen",
  "kind",
  "kindhearted",
  "kindly",
  "knotty",
  "knowing",
  "knowledgeable",
  "known",
  "labored",
  "lackadaisical",
  "lacking",
  "lame",
  "lamentable",
  "languid",
  "large",
  "last",
  "late",
  "laughable",
  "lavish",
  "lazy",
  "lean",
  "learned",
  "left",
  "legal",
  "lethal",
  "level",
  "lewd",
  "light",
  "like",
  "likeable",
  "limping",
  "literate",
  "little",
  "lively",
  "lively",
  "living",
  "lonely",
  "long",
  "longing",
  "long-term",
  "loose",
  "lopsided",
  "loud",
  "loutish",
  "lovely",
  "loving",
  "low",
  "lowly",
  "lucky",
  "ludicrous",
  "lumpy",
  "lush",
  "luxuriant",
  "lying",
  "lyrical",
  "macabre",
  "macho",
  "maddening",
  "madly",
  "magenta",
  "magical",
  "magnificent",
  "majestic",
  "makeshift",
  "male",
  "malicious",
  "mammoth",
  "maniacal",
  "many",
  "marked",
  "massive",
  "married",
  "marvelous",
  "material",
  "materialistic",
  "mature",
  "mean",
  "measly",
  "meaty",
  "medical",
  "meek",
  "mellow",
  "melodic",
  "melted",
  "merciful",
  "mere",
  "messy",
  "mighty",
  "military",
  "milky",
  "mindless",
  "miniature",
  "minor",
  "miscreant",
  "misty",
  "mixed",
  "moaning",
  "modern",
  "moldy",
  "momentous",
  "motionless",
  "mountainous",
  "muddled",
  "mundane",
  "murky",
  "mushy",
  "mute",
  "mysterious",
  "naive",
  "nappy",
  "narrow",
  "nasty",
  "natural",
  "naughty",
  "nauseating",
  "near",
  "neat",
  "nebulous",
  "necessary",
  "needless",
  "needy",
  "neighborly",
  "nervous",
  "new",
  "next",
  "nice",
  "nifty",
  "nimble",
  "nine",
  "nippy",
  "noiseless",
  "noisy",
  "nonchalant",
  "nondescript",
  "nonstop",
  "normal",
  "nostalgic",
  "nosy",
  "noxious",
  "null",
  "numberless",
  "numerous",
  "nutritious",
  "nutty",
  "oafish",
  "obedient",
  "obeisant",
  "obese",
  "obnoxious",
  "obscene",
  "obsequious",
  "observant",
  "obsolete",
  "obtainable",
  "oceanic",
  "odd",
  "offbeat",
  "old",
  "old-fashioned",
  "omniscient",
  "one",
  "onerous",
  "open",
  "opposite",
  "optimal",
  "orange",
  "ordinary",
  "organic",
  "ossified",
  "outgoing",
  "outrageous",
  "outstanding",
  "oval",
  "overconfident",
  "overjoyed",
  "overrated",
  "overt",
  "overwrought",
  "painful",
  "painstaking",
  "pale",
  "paltry",
  "panicky",
  "panoramic",
  "parallel",
  "parched",
  "parsimonious",
  "past",
  "pastoral",
  "pathetic",
  "peaceful",
  "penitent",
  "perfect",
  "periodic",
  "permissible",
  "perpetual",
  "petite",
  "petite",
  "phobic",
  "physical",
  "picayune",
  "pink",
  "piquant",
  "placid",
  "plain",
  "plant",
  "plastic",
  "plausible",
  "pleasant",
  "plucky",
  "pointless",
  "poised",
  "polite",
  "political",
  "poor",
  "possessive",
  "possible",
  "powerful",
  "precious",
  "premium",
  "present",
  "pretty",
  "previous",
  "pricey",
  "prickly",
  "private",
  "probable",
  "productive",
  "profuse",
  "protective",
  "proud",
  "psychedelic",
  "psychotic",
  "public",
  "puffy",
  "pumped",
  "puny",
  "purple",
  "purring",
  "pushy",
  "puzzled",
  "puzzling",
  "quack",
  "quaint",
  "quarrelsome",
  "questionable",
  "quick",
  "quickest",
  "quiet",
  "quirky",
  "quixotic",
  "quizzical",
  "rabid",
  "racial",
  "ragged",
  "rainy",
  "rambunctious",
  "rampant",
  "rapid",
  "rare",
  "raspy",
  "ratty",
  "ready",
  "real",
  "rebel",
  "receptive",
  "recondite",
  "red",
  "redundant",
  "reflective",
  "regular",
  "relieved",
  "remarkable",
  "reminiscent",
  "repulsive",
  "resolute",
  "resonant",
  "responsible",
  "rhetorical",
  "rich",
  "right",
  "righteous",
  "rightful",
  "rigid",
  "ripe",
  "ritzy",
  "roasted",
  "robust",
  "romantic",
  "roomy",
  "rotten",
  "rough",
  "round",
  "royal",
  "ruddy",
  "rude",
  "rural",
  "rustic",
  "ruthless",
  "sable",
  "sad",
  "safe",
  "salty",
  "same",
  "sassy",
  "satisfying",
  "savory",
  "scandalous",
  "scarce",
  "scared",
  "scary",
  "scattered",
  "scientific",
  "scintillating",
  "scrawny",
  "screeching",
  "second",
  "second-hand",
  "secret",
  "secretive",
  "sedate",
  "seemly",
  "selective",
  "selfish",
  "separate",
  "serious",
  "shaggy",
  "shaky",
  "shallow",
  "sharp",
  "shiny",
  "shivering",
  "shocking",
  "short",
  "shrill",
  "shut",
  "shy",
  "sick",
  "silent",
  "silent",
  "silky",
  "silly",
  "simple",
  "simplistic",
  "sincere",
  "six",
  "skillful",
  "skinny",
  "sleepy",
  "slim",
  "slimy",
  "slippery",
  "sloppy",
  "slow",
  "small",
  "smart",
  "smelly",
  "smiling",
  "smoggy",
  "smooth",
  "sneaky",
  "snobbish",
  "snotty",
  "soft",
  "soggy",
  "solid",
  "somber",
  "sophisticated",
  "sordid",
  "sore",
  "sore",
  "sour",
  "sparkling",
  "special",
  "spectacular",
  "spicy",
  "spiffy",
  "spiky",
  "spiritual",
  "spiteful",
  "splendid",
  "spooky",
  "spotless",
  "spotted",
  "spotty",
  "spurious",
  "squalid",
  "square",
  "squealing",
  "squeamish",
  "staking",
  "stale",
  "standing",
  "statuesque",
  "steadfast",
  "steady",
  "steep",
  "stereotyped",
  "sticky",
  "stiff",
  "stimulating",
  "stingy",
  "stormy",
  "straight",
  "strange",
  "striped",
  "strong",
  "stupendous",
  "stupid",
  "sturdy",
  "subdued",
  "subsequent",
  "substantial",
  "successful",
  "succinct",
  "sudden",
  "sulky",
  "super",
  "superb",
  "superficial",
  "supreme",
  "swanky",
  "sweet",
  "sweltering",
  "swift",
  "symptomatic",
  "synonymous",
  "taboo",
  "tacit",
  "tacky",
  "talented",
  "tall",
  "tame",
  "tan",
  "tangible",
  "tangy",
  "tart",
  "tasteful",
  "tasteless",
  "tasty",
  "tawdry",
  "tearful",
  "tedious",
  "teeny",
  "teeny-tiny",
  "telling",
  "temporary",
  "ten",
  "tender tense",
  "tense",
  "tenuous",
  "terrible",
  "terrific",
  "tested",
  "testy",
  "thankful",
  "therapeutic",
  "thick",
  "thin",
  "thinkable",
  "third",
  "thirsty",
  "thoughtful",
  "thoughtless",
  "threatening",
  "three",
  "thundering",
  "tidy",
  "tight",
  "tightfisted",
  "tiny",
  "tired",
  "tiresome",
  "toothsome",
  "torpid",
  "tough",
  "towering",
  "tranquil",
  "trashy",
  "tremendous",
  "tricky",
  "trite",
  "troubled",
  "truculent",
  "true",
  "truthful",
  "two",
  "typical",
  "ubiquitous",
  "ugliest",
  "ugly",
  "ultra",
  "unable",
  "unaccountable",
  "unadvised",
  "unarmed",
  "unbecoming",
  "unbiased",
  "uncovered",
  "understood",
  "undesirable",
  "unequal",
  "unequaled",
  "uneven",
  "unhealthy",
  "uninterested",
  "unique",
  "unkempt",
  "unknown",
  "unnatural",
  "unruly",
  "unsightly",
  "unsuitable",
  "untidy",
  "unused",
  "unusual",
  "unwieldy",
  "unwritten",
  "upbeat",
  "uppity",
  "upset",
  "uptight",
  "used",
  "useful",
  "useless",
  "utopian",
  "utter",
  "uttermost",
  "vacuous",
  "vagabond",
  "vague",
  "valuable",
  "various",
  "vast",
  "vengeful",
  "venomous",
  "verdant",
  "versed",
  "victorious",
  "vigorous",
  "violent",
  "violet",
  "vivacious",
  "voiceless",
  "volatile",
  "voracious",
  "vulgar",
  "wacky",
  "waggish",
  "waiting",
  "",
  "wakeful",
  "wandering",
  "wanting",
  "warlike",
  "warm",
  "wary",
  "wasteful",
  "watery",
  "weak",
  "wealthy",
  "weary",
  "well-groomed",
  "well-made",
  "well-off",
  "well-to-do",
  "wet",
  "whimsical",
  "whispering",
  "white",
  "whole",
  "wholesale",
  "wicked",
  "wide",
  "wide-eyed",
  "wiggly",
  "wild",
  "willing",
  "windy",
  "wiry",
  "wise",
  "wistful",
  "witty",
  "woebegone",
  "womanly",
  "wonderful",
  "wooden",
  "woozy",
  "workable",
  "worried",
  "worthless",
  "wrathful",
  "wretched",
  "wrong",
  "wry",
  "xenophobic",
  "yellow",
  "yielding",
  "young",
  "youthful",
  "yummy",
  "zany",
  "zealous",
  "zesty",
  "zippy",
  "zonked"
];

let nouns = [
  "accelerator",
  "accordion",
  "account",
  "accountant",
  "acknowledgment",
  "acoustic",
  "acrylic",
  "act",
  "action",
  "active",
  "activity",
  "actor",
  "actress",
  "adapter",
  "addition",
  "address",
  "adjustment",
  "adult",
  "advantage",
  "advertisement",
  "advice",
  "afghanistan",
  "africa",
  "aftermath",
  "afternoon",
  "aftershave",
  "afterthought",
  "age",
  "agenda",
  "agreement",
  "air",
  "airbus",
  "airmail",
  "airplane",
  "airport",
  "airship",
  "alarm",
  "albatross",
  "alcohol",
  "algebra",
  "algeria",
  "alibi",
  "alley",
  "alligator",
  "alloy",
  "almanac",
  "alphabet",
  "alto",
  "aluminium",
  "aluminum",
  "ambulance",
  "america",
  "amount",
  "amusement",
  "anatomy",
  "anethesiologist",
  "anger",
  "angle",
  "angora",
  "animal",
  "anime",
  "ankle",
  "answer",
  "ant",
  "antarctica",
  "anteater",
  "antelope",
  "anthony",
  "anthropology",
  "apartment",
  "apology",
  "apparatus",
  "apparel",
  "appeal",
  "appendix",
  "apple",
  "appliance",
  "approval",
  "april",
  "aquarius",
  "arch",
  "archaeology",
  "archeology",
  "archer",
  "architecture",
  "area",
  "argentina",
  "argument",
  "aries",
  "arithmetic",
  "arm",
  "armadillo",
  "armchair",
  "armenian",
  "army",
  "arrow",
  "art",
  "ash",
  "ashtray",
  "asia",
  "asparagus",
  "asphalt",
  "asterisk",
  "astronomy",
  "athlete",
  "atm",
  "atom",
  "attack",
  "attempt",
  "attention",
  "attic",
  "attraction",
  "august",
  "aunt",
  "australia",
  "australian",
  "author",
  "authorisation",
  "authority",
  "authorization",
  "avenue",
  "babies",
  "baboon",
  "baby",
  "back",
  "backbone",
  "bacon",
  "badge",
  "badger",
  "bag",
  "bagel",
  "bagpipe",
  "bail",
  "bait",
  "baker",
  "bakery",
  "balance",
  "balinese",
  "ball",
  "balloon",
  "bamboo",
  "banana",
  "band",
  "bandana",
  "bangladesh",
  "bangle",
  "banjo",
  "bank",
  "bankbook",
  "banker",
  "bar",
  "barbara",
  "barber",
  "barge",
  "baritone",
  "barometer",
  "base",
  "baseball",
  "basement",
  "basin",
  "basket",
  "basketball",
  "bass",
  "bassoon",
  "bat",
  "bath",
  "bathroom",
  "bathtub",
  "battery",
  "battle",
  "bay",
  "beach",
  "bead",
  "beam",
  "bean",
  "bear",
  "beard",
  "beast",
  "beat",
  "beautician",
  "beauty",
  "beaver",
  "bed",
  "bedroom",
  "bee",
  "beech",
  "beef",
  "beer",
  "beet",
  "beetle",
  "beggar",
  "beginner",
  "begonia",
  "behavior",
  "belgian",
  "belief",
  "believe",
  "bell",
  "belt",
  "bench",
  "bengal",
  "beret",
  "berry",
  "bestseller",
  "betty",
  "bibliography",
  "bicycle",
  "bike",
  "bill",
  "billboard",
  "biology",
  "biplane",
  "birch",
  "bird",
  "birth",
  "birthday",
  "bit",
  "bite",
  "black",
  "bladder",
  "blade",
  "blanket",
  "blinker",
  "blizzard",
  "block",
  "blood",
  "blouse",
  "blow",
  "blowgun",
  "blue",
  "board",
  "boat",
  "bobcat",
  "body",
  "bolt",
  "bomb",
  "bomber",
  "bone",
  "bongo",
  "bonsai",
  "book",
  "bookcase",
  "booklet",
  "boot",
  "border",
  "botany",
  "bottle",
  "bottom",
  "boundary",
  "bow",
  "bowl",
  "bowling",
  "box",
  "boy",
  "bra",
  "brace",
  "bracket",
  "brain",
  "brake",
  "branch",
  "brand",
  "brandy",
  "brass",
  "brazil",
  "bread",
  "break",
  "breakfast",
  "breath",
  "brian",
  "brick",
  "bridge",
  "british",
  "broccoli",
  "brochure",
  "broker",
  "bronze",
  "brother",
  "brother-in-law",
  "brow",
  "brown",
  "brush",
  "bubble",
  "bucket",
  "budget",
  "buffer",
  "buffet",
  "bugle",
  "building",
  "bulb",
  "bull",
  "bulldozer",
  "bumper",
  "bun",
  "burglar",
  "burma",
  "burn",
  "burst",
  "bus",
  "bush",
  "business",
  "butane",
  "butcher",
  "butter",
  "button",
  "buzzard",
  "c-clamp",
  "cabbage",
  "cabinet",
  "cable",
  "cactus",
  "cafe",
  "cake",
  "calculator",
  "calculus",
  "calendar",
  "calf",
  "call",
  "camel",
  "camera",
  "camp",
  "can",
  "canada",
  "canadian",
  "cancer",
  "candle",
  "cannon",
  "canoe",
  "canvas",
  "cap",
  "capital",
  "cappelletti",
  "capricorn",
  "captain",
  "caption",
  "car",
  "caravan",
  "carbon",
  "card",
  "cardboard",
  "cardigan",
  "care",
  "carnation",
  "carol",
  "carp",
  "carpenter",
  "carriage",
  "carrot",
  "cart",
  "cartoon",
  "case",
  "cast",
  "castanet",
  "cat",
  "catamaran",
  "caterpillar",
  "cathedral",
  "catsup",
  "cattle",
  "cauliflower",
  "cause",
  "caution",
  "cave",
  "cd",
  "ceiling",
  "celery",
  "celeste",
  "cell",
  "cellar",
  "cello",
  "celsius",
  "cement",
  "cemetery",
  "cent",
  "centimeter",
  "century",
  "ceramic",
  "cereal",
  "certification",
  "chain",
  "chair",
  "chalk",
  "chance",
  "change",
  "channel",
  "character",
  "chard",
  "charles",
  "chauffeur",
  "check",
  "cheek",
  "cheese",
  "cheetah",
  "chef",
  "chemistry",
  "cheque",
  "cherries",
  "cherry",
  "chess",
  "chest",
  "chick",
  "chicken",
  "chicory",
  "chief",
  "child",
  "children",
  "chill",
  "chime",
  "chimpanzee",
  "chin",
  "china",
  "chinese",
  "chive",
  "chocolate",
  "chord",
  "christmas",
  "christopher",
  "chronometer",
  "church",
  "cicada",
  "cinema",
  "circle",
  "circulation",
  "cirrus",
  "citizenship",
  "city",
  "clam",
  "clarinet",
  "class",
  "claus",
  "clave",
  "clef",
  "clerk",
  "click",
  "client",
  "climb",
  "clipper",
  "cloakroom",
  "clock",
  "close",
  "closet",
  "cloth",
  "cloud",
  "cloudy",
  "clover",
  "club",
  "clutch",
  "coach",
  "coal",
  "coast",
  "coat",
  "cobweb",
  "cockroach",
  "cocktail",
  "cocoa",
  "cod",
  "coffee",
  "coil",
  "coin",
  "coke",
  "cold",
  "collar",
  "college",
  "collision",
  "colombia",
  "colon",
  "colony",
  "color",
  "colt",
  "column",
  "columnist",
  "comb",
  "comfort",
  "comic",
  "comma",
  "command",
  "commission",
  "committee",
  "community",
  "company",
  "comparison",
  "competition",
  "competitor",
  "composer",
  "composition",
  "computer",
  "condition",
  "condor",
  "cone",
  "confirmation",
  "conga",
  "congo",
  "conifer",
  "connection",
  "consonant",
  "continent",
  "control",
  "cook",
  "cooking",
  "copper",
  "copy",
  "copyright",
  "cord",
  "cork",
  "cormorant",
  "corn",
  "cornet",
  "correspondent",
  "cost",
  "cotton",
  "couch",
  "cougar",
  "cough",
  "country",
  "course",
  "court",
  "cousin",
  "cover",
  "cow",
  "cowbell",
  "crab",
  "crack",
  "cracker",
  "craftsman",
  "crate",
  "crawdad",
  "crayfish",
  "crayon",
  "cream",
  "creator",
  "creature",
  "credit",
  "creditor",
  "creek",
  "crib",
  "cricket",
  "crime",
  "criminal",
  "crocodile",
  "crocus",
  "croissant",
  "crook",
  "crop",
  "cross",
  "crow",
  "crowd",
  "crown",
  "crush",
  "cry",
  "cub",
  "cuban",
  "cucumber",
  "cultivator",
  "cup",
  "cupboard",
  "cupcake",
  "curler",
  "currency",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custard",
  "customer",
  "cut",
  "cuticle",
  "cycle",
  "cyclone",
  "cylinder",
  "cymbal",
  "dad",
  "daffodil",
  "dahlia",
  "daisy",
  "damage",
  "dance",
  "dancer",
  "danger",
  "daniel",
  "dash",
  "dashboard",
  "database",
  "date",
  "daughter",
  "david",
  "day",
  "dead",
  "deadline",
  "deal",
  "death",
  "deborah",
  "debt",
  "debtor",
  "decade",
  "december",
  "decimal",
  "decision",
  "decrease",
  "dedication",
  "deer",
  "defense",
  "deficit",
  "degree",
  "delete",
  "delivery",
  "den",
  "denim",
  "dentist",
  "deodorant",
  "department",
  "deposit",
  "description",
  "desert",
  "design",
  "desire",
  "desk",
  "dessert",
  "destruction",
  "detail",
  "detective",
  "development",
  "dew",
  "diamond",
  "diaphragm",
  "dibble",
  "dictionary",
  "dietician",
  "difference",
  "digestion",
  "digger",
  "digital",
  "dill",
  "dime",
  "dimple",
  "dinghy",
  "dinner",
  "dinosaur",
  "diploma",
  "dipstick",
  "direction",
  "dirt",
  "disadvantage",
  "discovery",
  "discussion",
  "disease",
  "disgust",
  "dish",
  "distance",
  "distribution",
  "distributor",
  "diving",
  "division",
  "divorced",
  "dock",
  "doctor",
  "dog",
  "dogsled",
  "doll",
  "dollar",
  "dolphin",
  "domain",
  "donald",
  "donkey",
  "donna",
  "door",
  "dorothy",
  "double",
  "doubt",
  "downtown",
  "dragon",
  "dragonfly",
  "drain",
  "drake",
  "drama",
  "draw",
  "drawbridge",
  "drawer",
  "dream",
  "dredger",
  "dress",
  "dresser",
  "dressing",
  "drill",
  "drink",
  "drive",
  "driver",
  "driving",
  "drizzle",
  "drop",
  "drug",
  "drum",
  "dry",
  "dryer",
  "duck",
  "duckling",
  "dugout",
  "dungeon",
  "dust",
  "eagle",
  "ear",
  "earth",
  "earthquake",
  "ease",
  "east",
  "edge",
  "edger",
  "editor",
  "editorial",
  "education",
  "edward",
  "eel",
  "effect",
  "egg",
  "eggnog",
  "eggplant",
  "egypt",
  "eight",
  "elbow",
  "element",
  "elephant",
  "elizabeth",
  "ellipse",
  "emery",
  "employee",
  "employer",
  "encyclopedia",
  "end",
  "enemy",
  "energy",
  "engine",
  "engineer",
  "engineering",
  "english",
  "enquiry",
  "entrance",
  "environment",
  "epoch",
  "epoxy",
  "equinox",
  "equipment",
  "era",
  "error",
  "estimate",
  "ethernet",
  "ethiopia",
  "euphonium",
  "europe",
  "evening",
  "event",
  "ex-husband",
  "ex-wife",
  "examination",
  "example",
  "exchange",
  "exclamation",
  "exhaust",
  "existence",
  "expansion",
  "experience",
  "expert",
  "explanation",
  "eye",
  "eyebrow",
  "eyelash",
  "eyeliner",
  "face",
  "facilities",
  "fact",
  "factory",
  "fahrenheit",
  "fairies",
  "fall",
  "family",
  "fan",
  "fang",
  "farm",
  "farmer",
  "fat",
  "father",
  "father-in-law",
  "faucet",
  "fear",
  "feast",
  "feather",
  "feature",
  "february",
  "fedelini",
  "feedback",
  "feeling",
  "feet",
  "felony",
  "female",
  "fender",
  "ferry",
  "ferryboat",
  "fertilizer",
  "fiber",
  "fiberglass",
  "fibre",
  "fiction",
  "field",
  "fifth",
  "fight",
  "fighter",
  "file",
  "find",
  "fine",
  "finger",
  "fir",
  "fire",
  "fired",
  "fireman",
  "fireplace",
  "firewall",
  "fish",
  "fisherman",
  "flag",
  "flame",
  "flare",
  "flat",
  "flavor",
  "flax",
  "flesh",
  "flight",
  "flock",
  "flood",
  "floor",
  "flower",
  "flugelhorn",
  "flute",
  "fly",
  "foam",
  "fog",
  "fold",
  "font",
  "food",
  "foot",
  "football",
  "footnote",
  "force",
  "forecast",
  "forehead",
  "forest",
  "forgery",
  "fork",
  "form",
  "format",
  "fortnight",
  "foundation",
  "fountain",
  "fowl",
  "fox",
  "foxglove",
  "fragrance",
  "frame",
  "france",
  "freckle",
  "freeze",
  "freezer",
  "freighter",
  "french",
  "freon",
  "friction",
  "friday",
  "fridge",
  "friend",
  "frog",
  "front",
  "frost",
  "frown",
  "fruit",
  "fuel",
  "fur",
  "furniture",
  "galley",
  "gallon",
  "game",
  "gander",
  "garage",
  "garden",
  "garlic",
  "gas",
  "gasoline",
  "gate",
  "gateway",
  "gauge",
  "gazelle",
  "gear",
  "gearshift",
  "geese",
  "gemini",
  "gender",
  "geography",
  "geology",
  "geometry",
  "george",
  "geranium",
  "german",
  "germany",
  "ghana",
  "ghost",
  "giant",
  "giraffe",
  "girdle",
  "girl",
  "gladiolus",
  "glass",
  "glider",
  "gliding",
  "glockenspiel",
  "glove",
  "glue",
  "goal",
  "goat",
  "gold",
  "goldfish",
  "golf",
  "gondola",
  "gong",
  "good-bye",
  "goose",
  "gore-tex",
  "gorilla",
  "gosling",
  "government",
  "governor",
  "grade",
  "grain",
  "gram",
  "granddaughter",
  "grandfather",
  "grandmother",
  "grandson",
  "grape",
  "graphic",
  "grass",
  "grasshopper",
  "gray",
  "grease",
  "great-grandfather",
  "great-grandmother",
  "greece",
  "greek",
  "green",
  "grenade",
  "grey",
  "grill",
  "grip",
  "ground",
  "group",
  "grouse",
  "growth",
  "guarantee",
  "guatemalan",
  "guide",
  "guilty",
  "guitar",
  "gum",
  "gun",
  "gym",
  "gymnast",
  "hacksaw",
  "hail",
  "hair",
  "haircut",
  "half-brother",
  "half-sister",
  "halibut",
  "hall",
  "hallway",
  "hamburger",
  "hammer",
  "hamster",
  "hand",
  "handball",
  "handicap",
  "handle",
  "handsaw",
  "harbor",
  "hardboard",
  "hardcover",
  "hardhat",
  "hardware",
  "harmonica",
  "harmony",
  "harp",
  "hat",
  "hate",
  "hawk",
  "head",
  "headlight",
  "headline",
  "health",
  "hearing",
  "heart",
  "heat",
  "heaven",
  "hedge",
  "height",
  "helen",
  "helicopter",
  "helium",
  "hell",
  "helmet",
  "help",
  "hemp",
  "hen",
  "heron",
  "herring",
  "hexagon",
  "hill",
  "himalayan",
  "hip",
  "hippopotamus",
  "history",
  "hobbies",
  "hockey",
  "hoe",
  "hole",
  "holiday",
  "home",
  "honey",
  "hood",
  "hook",
  "hope",
  "horn",
  "horse",
  "hose",
  "hospital",
  "hot",
  "hour",
  "hourglass",
  "house",
  "hovercraft",
  "hub",
  "hubcap",
  "humidity",
  "humor",
  "hurricane",
  "hyacinth",
  "hydrant",
  "hydrofoil",
  "hydrogen",
  "hyena",
  "hygienic",
  "ice",
  "icebreaker",
  "icicle",
  "icon",
  "idea",
  "ikebana",
  "illegal",
  "imprisonment",
  "improvement",
  "impulse",
  "inch",
  "income",
  "increase",
  "index",
  "india",
  "indonesia",
  "industry",
  "ink",
  "innocent",
  "input",
  "insect",
  "instruction",
  "instrument",
  "insulation",
  "insurance",
  "interactive",
  "interest",
  "internet",
  "interviewer",
  "intestine",
  "invention",
  "inventory",
  "invoice",
  "iran",
  "iraq",
  "iris",
  "iron",
  "island",
  "israel",
  "italian",
  "italy",
  "jacket",
  "jaguar",
  "jail",
  "jam",
  "james",
  "january",
  "japan",
  "japanese",
  "jar",
  "jasmine",
  "jason",
  "jaw",
  "jeans",
  "jeep",
  "jeff",
  "jelly",
  "jellyfish",
  "jennifer",
  "jet",
  "jewel",
  "jogging",
  "john",
  "join",
  "joke",
  "joseph",
  "journey",
  "judge",
  "judo",
  "juice",
  "july",
  "jumbo",
  "jump",
  "jumper",
  "june",
  "jury",
  "justice",
  "jute",
  "kale",
  "kamikaze",
  "kangaroo",
  "karate",
  "karen",
  "kayak",
  "kendo",
  "kenneth",
  "kenya",
  "ketchup",
  "kettle",
  "kettledrum",
  "kevin",
  "key",
  "keyboard",
  "keyboarding",
  "kick",
  "kidney",
  "kilogram",
  "kilometer",
  "kimberly",
  "kiss",
  "kitchen",
  "kite",
  "kitten",
  "kitty",
  "knee",
  "knickers",
  "knife",
  "knight",
  "knot",
  "knowledge",
  "kohlrabi",
  "korean",
  "laborer",
  "lace",
  "ladybug",
  "lake",
  "lamb",
  "lamp",
  "lan",
  "land",
  "landmine",
  "language",
  "larch",
  "lasagna",
  "latency",
  "latex",
  "lathe",
  "laugh",
  "laundry",
  "laura",
  "law",
  "lawyer",
  "layer",
  "lead",
  "leaf",
  "learning",
  "leather",
  "leek",
  "leg",
  "legal",
  "lemonade",
  "lentil",
  "leo",
  "leopard",
  "letter",
  "lettuce",
  "level",
  "libra",
  "library",
  "license",
  "lier",
  "lift",
  "light",
  "lightning",
  "lilac",
  "lily",
  "limit",
  "linda",
  "line",
  "linen",
  "link",
  "lion",
  "lip",
  "lipstick",
  "liquid",
  "liquor",
  "lisa",
  "list",
  "literature",
  "litter",
  "liver",
  "lizard",
  "llama",
  "loaf",
  "loan",
  "lobster",
  "lock",
  "locket",
  "locust",
  "look",
  "loss",
  "lotion",
  "love",
  "low",
  "lumber",
  "lunch",
  "lunchroom",
  "lung",
  "lunge",
  "lute",
  "luttuce",
  "lycra",
  "lynx",
  "lyocell",
  "lyre",
  "lyric",
  "macaroni",
  "machine",
  "macrame",
  "magazine",
  "magic",
  "magician",
  "maid",
  "mail",
  "mailbox",
  "mailman",
  "makeup",
  "malaysia",
  "male",
  "mall",
  "mallet",
  "man",
  "manager",
  "mandolin",
  "manicure",
  "manx",
  "map",
  "maple",
  "maraca",
  "marble",
  "march",
  "margaret",
  "margin",
  "maria",
  "marimba",
  "mark",
  "market",
  "married",
  "mary",
  "mascara",
  "mask",
  "mass",
  "match",
  "math",
  "mattock",
  "may",
  "mayonnaise",
  "meal",
  "measure",
  "meat",
  "mechanic",
  "medicine",
  "meeting",
  "melody",
  "memory",
  "men",
  "menu",
  "mercury",
  "message",
  "metal",
  "meteorology",
  "meter",
  "methane",
  "mexican",
  "mexico",
  "mice",
  "michael",
  "michelle",
  "microwave",
  "middle",
  "mile",
  "milk",
  "milkshake",
  "millennium",
  "millimeter",
  "millisecond",
  "mimosa",
  "mind",
  "mine",
  "mini-skirt",
  "minibus",
  "minister",
  "mint",
  "minute",
  "mirror",
  "missile",
  "mist",
  "mistake",
  "mitten",
  "moat",
  "modem",
  "mole",
  "mom",
  "monday",
  "money",
  "monkey",
  "month",
  "moon",
  "morning",
  "morocco",
  "mosque",
  "mosquito",
  "mother",
  "mother-in-law",
  "motion",
  "motorboat",
  "motorcycle",
  "mountain",
  "mouse",
  "moustache",
  "mouth",
  "move",
  "multi-hop",
  "multimedia",
  "muscle",
  "museum",
  "music",
  "musician",
  "mustard",
  "myanmar",
  "nail",
  "name",
  "nancy",
  "napkin",
  "narcissus",
  "nation",
  "neck",
  "need",
  "needle",
  "neon",
  "nepal",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "news",
  "newsprint",
  "newsstand",
  "nic",
  "nickel",
  "niece",
  "nigeria",
  "night",
  "nitrogen",
  "node",
  "noise",
  "noodle",
  "north",
  "north america",
  "north korea",
  "norwegian",
  "nose",
  "note",
  "notebook",
  "notify",
  "novel",
  "november",
  "number",
  "numeric",
  "nurse",
  "nut",
  "nylon",
  "oak",
  "oatmeal",
  "objective",
  "oboe",
  "observation",
  "occupation",
  "ocean",
  "ocelot",
  "octagon",
  "octave",
  "october",
  "octopus",
  "odometer",
  "offence",
  "offer",
  "office",
  "oil",
  "okra",
  "olive",
  "onion",
  "open",
  "opera",
  "operation",
  "ophthalmologist",
  "opinion",
  "option",
  "orange",
  "orchestra",
  "orchid",
  "order",
  "organ",
  "organisation",
  "organization",
  "ornament",
  "ostrich",
  "otter",
  "ounce",
  "output",
  "outrigger",
  "oval",
  "oven",
  "overcoat",
  "owl",
  "owner",
  "ox",
  "oxygen",
  "oyster",
  "package",
  "packet",
  "page",
  "pail",
  "pain",
  "paint",
  "pair",
  "pajama",
  "pakistan",
  "palm",
  "pamphlet",
  "pan",
  "pancake",
  "pancreas",
  "panda",
  "pansy",
  "panther",
  "panties",
  "pantry",
  "pants",
  "panty",
  "pantyhose",
  "paper",
  "paperback",
  "parade",
  "parallelogram",
  "parcel",
  "parent",
  "parentheses",
  "park",
  "parrot",
  "parsnip",
  "part",
  "particle",
  "partner",
  "partridge",
  "party",
  "passbook",
  "passenger",
  "passive",
  "pasta",
  "paste",
  "pastor",
  "pastry",
  "patch",
  "path",
  "patient",
  "patio",
  "patricia",
  "paul",
  "payment",
  "pea",
  "peace",
  "peak",
  "peanut",
  "pear",
  "pedestrian",
  "pediatrician",
  "peen",
  "peer-to-peer",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "pendulum",
  "pentagon",
  "peony",
  "pepper",
  "perch",
  "perfume",
  "period",
  "periodical",
  "peripheral",
  "permission",
  "persian",
  "person",
  "peru",
  "pest",
  "pet",
  "pharmacist",
  "pheasant",
  "philippines",
  "philosophy",
  "phone",
  "physician",
  "piano",
  "piccolo",
  "pickle",
  "picture",
  "pie",
  "pig",
  "pigeon",
  "pike",
  "pillow",
  "pilot",
  "pimple",
  "pin",
  "pine",
  "ping",
  "pink",
  "pint",
  "pipe",
  "pisces",
  "pizza",
  "place",
  "plain",
  "plane",
  "planet",
  "plant",
  "plantation",
  "plaster",
  "plasterboard",
  "plastic",
  "plate",
  "platinum",
  "play",
  "playground",
  "playroom",
  "pleasure",
  "plier",
  "plot",
  "plough",
  "plow",
  "plywood",
  "pocket",
  "poet",
  "point",
  "poison",
  "poland",
  "police",
  "policeman",
  "polish",
  "politician",
  "pollution",
  "polo",
  "polyester",
  "pond",
  "popcorn",
  "poppy",
  "population",
  "porch",
  "porcupine",
  "port",
  "porter",
  "position",
  "possibility",
  "postage",
  "postbox",
  "pot",
  "potato",
  "poultry",
  "pound",
  "powder",
  "power",
  "precipitation",
  "preface",
  "prepared",
  "pressure",
  "price",
  "priest",
  "print",
  "printer",
  "prison",
  "probation",
  "process",
  "processing",
  "produce",
  "product",
  "production",
  "professor",
  "profit",
  "promotion",
  "propane",
  "property",
  "prose",
  "prosecution",
  "protest",
  "protocol",
  "pruner",
  "psychiatrist",
  "psychology",
  "ptarmigan",
  "puffin",
  "pull",
  "puma",
  "pump",
  "pumpkin",
  "punch",
  "punishment",
  "puppy",
  "purchase",
  "purple",
  "purpose",
  "push",
  "pvc",
  "pyjama",
  "pyramid",
  "quail",
  "quality",
  "quart",
  "quarter",
  "quartz",
  "queen",
  "question",
  "quicksand",
  "quiet",
  "quill",
  "quilt",
  "quince",
  "quit",
  "quiver",
  "quotation",
  "rabbi",
  "rabbit",
  "racing",
  "radar",
  "radiator",
  "radio",
  "radish",
  "raft",
  "rail",
  "railway",
  "rain",
  "rainbow",
  "raincoat",
  "rainstorm",
  "rake",
  "ramie",
  "random",
  "range",
  "rat",
  "rate",
  "raven",
  "ravioli",
  "ray",
  "rayon",
  "reaction",
  "reading",
  "reason",
  "receipt",
  "recess",
  "record",
  "recorder",
  "rectangle",
  "red",
  "reduction",
  "refrigerator",
  "refund",
  "regret",
  "reindeer",
  "relation",
  "relative",
  "religion",
  "relish",
  "reminder",
  "repair",
  "replace",
  "report",
  "representative",
  "request",
  "resolution",
  "respect",
  "responsibility",
  "rest",
  "restaurant",
  "result",
  "retailer",
  "revolve",
  "revolver",
  "reward",
  "rhinoceros",
  "rhythm",
  "rice",
  "richard",
  "riddle",
  "rifle",
  "ring",
  "rise",
  "risk",
  "river",
  "riverbed",
  "road",
  "roadway",
  "roast",
  "robert",
  "robin",
  "rock",
  "rocket",
  "rod",
  "roll",
  "romania",
  "romanian",
  "ronald",
  "roof",
  "room",
  "rooster",
  "root",
  "rose",
  "rotate",
  "route",
  "router",
  "rowboat",
  "rub",
  "rubber",
  "rugby",
  "rule",
  "run",
  "russia",
  "russian",
  "rutabaga",
  "ruth",
  "sack",
  "sagittarius",
  "sail",
  "sailboat",
  "sailor",
  "salad",
  "salary",
  "sale",
  "salesman",
  "salmon",
  "salt",
  "sampan",
  "samurai",
  "sand",
  "sandra",
  "sandwich",
  "santa",
  "sarah",
  "sardine",
  "satin",
  "saturday",
  "sauce",
  "saudi arabia",
  "sausage",
  "save",
  "saw",
  "saxophone",
  "scale",
  "scallion",
  "scanner",
  "scarecrow",
  "scarf",
  "scene",
  "scent",
  "schedule",
  "school",
  "science",
  "scissors",
  "scooter",
  "scorpio",
  "scorpion",
  "scraper",
  "screen",
  "screw",
  "screwdriver",
  "sea",
  "seagull",
  "seal",
  "seaplane",
  "search",
  "seashore",
  "season",
  "seat",
  "second",
  "secretary",
  "secure",
  "security",
  "seed",
  "seeder",
  "segment",
  "select",
  "selection",
  "self",
  "semicircle",
  "semicolon",
  "sense",
  "sentence",
  "separated",
  "september",
  "servant",
  "server",
  "session",
  "sex",
  "shade",
  "shadow",
  "shake",
  "shallot",
  "shame",
  "shampoo",
  "shape",
  "share",
  "shark",
  "sharon",
  "shears",
  "sheep",
  "sheet",
  "shelf",
  "shell",
  "shield",
  "shingle",
  "ship",
  "shirt",
  "shock",
  "shoe",
  "shoemaker",
  "shop",
  "shorts",
  "shoulder",
  "shovel",
  "show",
  "shrimp",
  "shrine",
  "siamese",
  "siberian",
  "side",
  "sideboard",
  "sidecar",
  "sidewalk",
  "sign",
  "signature",
  "silica",
  "silk",
  "silver",
  "sing",
  "singer",
  "single",
  "sink",
  "sister",
  "sister-in-law",
  "size",
  "skate",
  "skiing",
  "skill",
  "skin",
  "skirt",
  "sky",
  "slash",
  "slave",
  "sled",
  "sleep",
  "sleet",
  "slice",
  "slime",
  "slip",
  "slipper",
  "slope",
  "smash",
  "smell",
  "smile",
  "smoke",
  "snail",
  "snake",
  "sneeze",
  "snow",
  "snowboarding",
  "snowflake",
  "snowman",
  "snowplow",
  "snowstorm",
  "soap",
  "soccer",
  "society",
  "sociology",
  "sock",
  "soda",
  "sofa",
  "softball",
  "softdrink",
  "software",
  "soil",
  "soldier",
  "son",
  "song",
  "soprano",
  "sort",
  "sound",
  "soup",
  "sousaphone",
  "south africa",
  "south america",
  "south korea",
  "soy",
  "soybean",
  "space",
  "spade",
  "spaghetti",
  "spain",
  "spandex",
  "spark",
  "sparrow",
  "spear",
  "specialist",
  "speedboat",
  "sphere",
  "sphynx",
  "spider",
  "spike",
  "spinach",
  "spleen",
  "sponge",
  "spoon",
  "spot",
  "spring",
  "sprout",
  "spruce",
  "spy",
  "square",
  "squash",
  "squid",
  "squirrel",
  "stage",
  "staircase",
  "stamp",
  "star",
  "start",
  "starter",
  "state",
  "statement",
  "station",
  "statistic",
  "steam",
  "steel",
  "stem",
  "step",
  "step-aunt",
  "step-brother",
  "step-daughter",
  "step-father",
  "step-grandfather",
  "step-grandmother",
  "step-mother",
  "step-sister",
  "step-son",
  "step-uncle",
  "stepdaughter",
  "stepmother",
  "stepson",
  "steven",
  "stew",
  "stick",
  "stinger",
  "stitch",
  "stock",
  "stocking",
  "stomach",
  "stone",
  "stool",
  "stop",
  "stopsign",
  "stopwatch",
  "store",
  "storm",
  "story",
  "stove",
  "stranger",
  "straw",
  "stream",
  "street",
  "streetcar",
  "stretch",
  "string",
  "structure",
  "study",
  "sturgeon",
  "submarine",
  "substance",
  "subway",
  "success",
  "sudan",
  "suede",
  "sugar",
  "suggestion",
  "suit",
  "summer",
  "sun",
  "sunday",
  "sundial",
  "sunflower",
  "sunshine",
  "supermarket",
  "supply",
  "support",
  "surfboard",
  "surgeon",
  "surname",
  "surprise",
  "susan",
  "sushi",
  "swallow",
  "swamp",
  "swan",
  "sweater",
  "sweatshirt",
  "sweatshop",
  "swedish",
  "sweets",
  "swim",
  "swimming",
  "swing",
  "swiss",
  "switch",
  "sword",
  "swordfish",
  "sycamore",
  "syria",
  "syrup",
  "system",
  "t-shirt",
  "table",
  "tablecloth",
  "tabletop",
  "tachometer",
  "tadpole",
  "tail",
  "tailor",
  "taiwan",
  "talk",
  "tank",
  "tanker",
  "tanzania",
  "target",
  "taste",
  "taurus",
  "tax",
  "taxi",
  "taxicab",
  "tea",
  "teacher",
  "teaching",
  "team",
  "technician",
  "teeth",
  "television",
  "teller",
  "temper",
  "temperature",
  "temple",
  "tempo",
  "tendency",
  "tennis",
  "tenor",
  "tent",
  "territory",
  "test",
  "text",
  "textbook",
  "texture",
  "thailand",
  "theater",
  "theory",
  "thermometer",
  "thing",
  "thistle",
  "thomas",
  "thought",
  "thread",
  "thrill",
  "throat",
  "throne",
  "thumb",
  "thunder",
  "thunderstorm",
  "thursday",
  "ticket",
  "tie",
  "tiger",
  "tights",
  "tile",
  "timbale",
  "time",
  "timer",
  "timpani",
  "tin",
  "tip",
  "tire",
  "titanium",
  "title",
  "toad",
  "toast",
  "toe",
  "toenail",
  "toilet",
  "tom-tom",
  "tomato",
  "ton",
  "tongue",
  "tooth",
  "toothbrush",
  "toothpaste",
  "top",
  "tornado",
  "tortellini",
  "tortoise",
  "touch",
  "tower",
  "town",
  "toy",
  "tractor",
  "trade",
  "traffic",
  "trail",
  "train",
  "tramp",
  "transaction",
  "transmission",
  "transport",
  "trapezoid",
  "tray",
  "treatment",
  "tree",
  "trial",
  "triangle",
  "trick",
  "trigonometry",
  "trip",
  "trombone",
  "trouble",
  "trousers",
  "trout",
  "trowel",
  "truck",
  "trumpet",
  "trunk",
  "tsunami",
  "tub",
  "tuba",
  "tuesday",
  "tugboat",
  "tulip",
  "tuna",
  "tune",
  "turkey",
  "turkish",
  "turn",
  "turnip",
  "turnover",
  "turret",
  "turtle",
  "tv",
  "twig",
  "twilight",
  "twine",
  "twist",
  "typhoon",
  "tyvek",
  "uganda",
  "ukraine",
  "ukrainian",
  "umbrella",
  "uncle",
  "underclothes",
  "underpants",
  "undershirt",
  "underwear",
  "unit",
  "united kingdom",
  "unshielded",
  "use",
  "utensil",
  "uzbekistan",
  "vacation",
  "vacuum",
  "valley",
  "value",
  "van",
  "var verbs = [aardvark",
  "vase",
  "vault",
  "vegetable",
  "vegetarian",
  "veil",
  "vein",
  "velvet",
  "venezuela",
  "venezuelan",
  "verdict",
  "vermicelli",
  "verse",
  "vessel",
  "vest",
  "veterinarian",
  "vibraphone",
  "vietnam",
  "view",
  "vinyl",
  "viola",
  "violet",
  "violin",
  "virgo",
  "viscose",
  "vise",
  "vision",
  "visitor",
  "voice",
  "volcano",
  "volleyball",
  "voyage",
  "vulture",
  "waiter",
  "waitress",
  "walk",
  "wall",
  "wallaby",
  "wallet",
  "walrus",
  "war",
  "warm",
  "wash",
  "washer",
  "wasp",
  "waste",
  "watch",
  "watchmaker",
  "water",
  "waterfall",
  "wave",
  "wax",
  "way",
  "wealth",
  "weapon",
  "weasel",
  "weather",
  "wedge",
  "wednesday",
  "weed",
  "weeder",
  "week",
  "weight",
  "whale",
  "wheel",
  "whip",
  "whiskey",
  "whistle",
  "white",
  "wholesaler",
  "whorl",
  "wilderness",
  "william",
  "willow",
  "wind",
  "windchime",
  "window",
  "windscreen",
  "windshield",
  "wine",
  "wing",
  "winter",
  "wire",
  "wish",
  "witch",
  "withdrawal",
  "witness",
  "wolf",
  "woman",
  "women",
  "wood",
  "wool",
  "woolen",
  "word",
  "work",
  "workshop",
  "worm",
  "wound",
  "wrecker",
  "wren",
  "wrench",
  "wrinkle",
  "wrist",
  "writer",
  "xylophone",
  "yacht",
  "yak",
  "yam",
  "yard",
  "yarn",
  "year",
  "yellow",
  "yew",
  "yogurt",
  "yoke",
  "yugoslavian",
  "zebra",
  "zephyr",
  "zinc",
  "zipper",
  "zone",
  "zoo",
  "zoology"
];

let adverbs = [
  "finally",
  "additionally",
  "interestingly",
  "recently",
  "importantly",
  "similarly",
  "surprisingly",
  "specifically",
  "conversely",
  "consequently",
  "collectively",
  "currently",
  "accordingly",
  "notably",
  "subsequently",
  "previously",
  "unfortunately",
  "remarkably",
  "unexpectedly",
  "lastly",
  "strikingly",
  "secondly",
  "alternatively",
  "intriguingly",
  "generally",
  "firstly",
  "italy",
  "consistently",
  "initially",
  "significantly",
  "traditionally",
  "ultimately",
  "histologically",
  "particularly",
  "typically",
  "clinically",
  "mechanistically",
  "historically",
  "simultaneously",
  "paradoxically",
  "postoperatively",
  "concomitantly",
  "correspondingly",
  "globally",
  "presently",
  "especially",
  "functionally",
  "usually",
  "concurrently",
  "ideally",
  "thirdly",
  "apparently",
  "immunohistochemically",
  "microscopically",
  "clearly",
  "july",
  "eventually",
  "crucially",
  "fortunately",
  "occasionally",
  "increasingly",
  "histopathologically",
  "critically",
  "rarely",
  "namely",
  "totally",
  "normally",
  "briefly",
  "theoretically",
  "frequently",
  "morphologically",
  "intraoperatively",
  "presumably",
  "actually",
  "curiously",
  "experimentally",
  "obviously",
  "ultrastructurally",
  "preoperatively",
  "conclusively",
  "classically",
  "cumulatively",
  "retrospectively",
  "commonly",
  "evidently",
  "inversely",
  "behaviorally",
  "conventionally",
  "noticeably",
  "possibly",
  "statistically",
  "contrarily",
  "grossly",
  "hopefully",
  "reciprocally",
  "potentially",
  "structurally",
  "essentially",
  "probably",
  "radiographically",
  "separately",
  "macroscopically",
  "individually",
  "physiologically",
  "biochemically",
  "lately",
  "nationally",
  "approximately",
  "quantitatively",
  "radiologically",
  "uniquely",
  "incidentally",
  "comparatively",
  "concordantly",
  "qualitatively",
  "basically",
  "broadly",
  "early",
  "sicily",
  "pathologically",
  "internationally",
  "conceivably",
  "phylogenetically",
  "conceptually",
  "contrastingly",
  "independently",
  "intuitively",
  "analogously",
  "annually",
  "equally",
  "primarily",
  "arguably",
  "certainly",
  "ironically",
  "originally",
  "undoubtedly",
  "mostly",
  "phenotypically",
  "family",
  "secondarily",
  "specially",
  "expectedly",
  "genetically",
  "prospectively",
  "encouragingly",
  "fourthly",
  "mathematically",
  "naturally",
  "worryingly",
  "unsurprisingly",
  "anatomically",
  "characteristically",
  "differently",
  "likely",
  "locally",
  "reportedly",
  "technically",
  "alternately",
  "respectively",
  "coincidentally",
  "counterintuitively",
  "immediately",
  "predictably",
  "unusually",
  "longitudinally",
  "methodologically",
  "practically",
  "additionaly",
  "biologically",
  "sadly",
  "computationally",
  "geographically",
  "molecularly",
  "precisely",
  "regrettably",
  "amazingly",
  "consequentially",
  "empirically",
  "inevitably",
  "preferably",
  "spatially",
  "anecdotally",
  "evolutionarily",
  "only",
  "periodically",
  "perioperatively",
  "predominantly",
  "reassuringly",
  "serologically",
  "congruently",
  "cytologically",
  "daily",
  "hypothetically",
  "intracellularly",
  "mainly",
  "regionally",
  "relatively",
  "acutely",
  "assembly",
  "astonishingly",
  "behaviourally",
  "developmentally",
  "endoscopically",
  "kelly",
  "neuropathologically",
  "overwhelmingly",
  "principally",
  "relevantly",
  "routinely",
  "serendipitously",
  "tentatively",
  "virtually",
  "concretely",
  "electrophysiologically",
  "exceptionally",
  "exemplarily",
  "extracellularly",
  "formally",
  "formerly",
  "fundamentally",
  "gradually",
  "immunologically",
  "invariably",
  "jointly",
  "largely",
  "lilly",
  "logically",
  "nearly",
  "operationally",
  "optimally",
  "postnatally",
  "subjectively",
  "successively",
  "temporally",
  "understandably",
  "admittedly",
  "analytically",
  "complementarily",
  "consecutively",
  "cytochemically",
  "dentsply",
  "epidemiologically",
  "excitingly",
  "externally",
  "histochemically",
  "immunocytochemically",
  "impressively",
  "kinetically",
  "pathophysiologically",
  "pharmacologically",
  "reilly",
  "systemically",
  "uncommonly",
  "alarmingly",
  "architecturally",
  "bilaterally",
  "biomechanically",
  "centrally",
  "coincidently",
  "conservatively",
  "contemporaneously",
  "contextually",
  "disappointingly",
  "distally",
  "ecologically",
  "effectively",
  "ethnically",
  "fascinatingly",
  "histomorphometrically",
  "immunohistologically",
  "infrequently",
  "jelly",
  "markedly",
  "neurally",
  "numerically",
  "oppositely",
  "optionally",
  "physically",
  "posteriorly",
  "preclinically",
  "progressively",
  "reversely",
  "suddenly",
  "summarily",
  "taxonomically",
  "therapeutically",
  "topologically",
  "unprecedentedly",
  "anaerobically",
  "analogically",
  "angiographically",
  "antenatally",
  "atypically",
  "bailly",
  "baly",
  "chemically",
  "chronically",
  "chronologically",
  "commercially",
  "connolly",
  "correlatively",
  "customarily",
  "elderly",
  "etiologically",
  "explicitly",
  "fittingly",
  "fortuitously",
  "implicitly",
  "indirectly",
  "intrestingly",
  "laparoscopically",
  "latterly",
  "mechanically",
  "metrically",
  "microbiologically",
  "multivariately",
  "neurobiologically",
  "neurophysiologically",
  "oddly",
  "ordinarily",
  "peripherally",
  "pharmacodynamically",
  "postprandially",
  "preliminarily",
  "proportionally",
  "randomly",
  "realistically",
  "roughly",
  "scientifically",
  "scully",
  "superfamily",
  "suprisingly",
  "surgically",
  "tellingly",
  "thankfully",
  "thessaly",
  "timely",
  "unpredictably",
  "visually",
  "accordantly",
  "aditionally",
  "aerobically",
  "algorithmically",
  "arthroscopically",
  "biophysically",
  "bizarrely",
  "booly",
  "chiefly",
  "clinicopathologically",
  "coherently",
  "collaterally",
  "comprehensively",
  "considerably",
  "conspicuously",
  "continuously",
  "conversly",
  "corroboratively",
  "cytogenetically",
  "definitely",
  "demographically",
  "dfly",
  "diagnostically",
  "disconcertingly",
  "distinctively",
  "disturbingly",
  "ectrodactyly",
  "embryologically",
  "emotionally",
  "energetically",
  "ethically",
  "geometrically",
  "hemodynamically",
  "inexplicably",
  "informally",
  "interestedly",
  "intermittently",
  "internally",
  "intraorally",
  "intrinsically",
  "iteratively",
  "jekely",
  "joly",
  "lamentably",
  "luckily",
  "maternally",
  "medicinally",
  "micrencephaly",
  "minimally",
  "monthly",
  "morally",
  "morphometrically",
  "multivariably",
  "neuroanatomically",
  "neurochemically",
  "neurologically",
  "notablely",
  "opportunely",
  "orally",
  "ostensibly",
  "parallely",
  "parenthetically",
  "partially",
  "partly",
  "pathogenetically",
  "peroperatively",
  "phytogeographically",
  "postmeiotically",
  "postsynaptically",
  "prenatally",
  "prognostically",
  "proximally",
  "psychologically",
  "psychophysically",
  "putatively",
  "puzzlingly",
  "rapidly",
  "regretfully",
  "regularly",
  "relatedly",
  "seasonally",
  "sequentially",
  "simplistically",
  "singly",
  "speculatively",
  "spindly",
  "splenomegaly",
  "spontaneously",
  "sporadically",
  "successfully",
  "superficially",
  "supposedly",
  "symptomatically",
  "systematically",
  "terminally",
  "topically",
  "ultrasonographically",
  "uniformly",
  "univariately",
  "unlikely",
  "yearly",
  "aboaly",
  "acceptably",
  "accidentally",
  "acly",
  "acromegaly",
  "additionly",
  "additonally",
  "advantageously",
  "adventitiously",
  "adversely",
  "advisably",
  "aesthetically",
  "aetiologically",
  "affectively",
  "allegedly",
  "anteriorly",
  "apically",
  "appropriately",
  "archaeologically",
  "arespectively",
  "bacteriologically",
  "bareilly",
  "basally",
  "beautifully",
  "beverly",
  "bioinformatically",
  "biosynthetically",
  "bodily",
  "byerly",
  "canonically",
  "causally",
  "cellularly",
  "cephalometrically",
  "clasically",
  "climatologically",
  "coincidingly",
  "comparably",
  "compatibly",
  "compellingly",
  "complimentarily",
  "concordingly",
  "concurringly",
  "conformably",
  "conjecturally",
  "connoly",
  "consquentially",
  "constitutively",
  "contradictorily",
  "controversly",
  "conversantly",
  "coronally",
  "cosmetically",
  "covalently",
  "cranially",
  "culturally",
  "curiosly",
  "cytomorphologically",
  "cytopathologically",
  "decisively",
  "delightfully",
  "densply",
  "descriptively",
  "desirably",
  "dewailly",
  "dimensionally",
  "directly",
  "disappointedly",
  "distinctly",
  "dolly",
  "echographically",
  "electronically",
  "electronmicroscopically",
  "electrophoretically",
  "emphatically",
  "endogenously",
  "endosonographically",
  "enthrallingly",
  "enzymatically",
  "erroneously",
  "ethnopharmacologically",
  "evocatively",
  "exclusively",
  "expectably",
  "expectantly",
  "extragingivally",
  "extraorally",
  "extremely",
  "feasibly",
  "feraly",
  "fifthly",
  "finallly",
  "findingsinitially",
  "focally",
  "frustratingly",
  "ganguly",
  "generically",
  "genomically",
  "genotypically",
  "gergely",
  "gratifyingly",
  "greely",
  "gully",
  "habitually",
  "happily",
  "hemperly",
  "hepatosplenomegaly",
  "hisologically",
  "holly",
  "holoprosencephaly",
  "hooghly",
  "identically",
  "ignificantly",
  "immuhistochemically",
  "immunochemically",
  "immunophenotypically",
  "inadvertently",
  "indisputably",
  "industrially",
  "inferiorly",
  "inherently",
  "inspiringly",
  "interspecifically",
  "interstingly",
  "intialy",
  "intradurally",
  "intrahepatically",
  "intralysosomally",
  "intraperitonally",
  "intraspecifically",
  "intriguinly",
  "intringuingly",
  "ipsilaterally",
  "isely",
  "karunagappally",
  "karyologically",
  "lally",
  "laterally",
  "legally",
  "lily",
  "literally",
  "logistically",
  "lovely",
  "macropharmacologically",
  "marginally",
  "metabolically",
  "meteorologically",
  "methodically",
  "microcephaly",
  "microregionally",
  "moberly",
  "modestly",
  "muhly",
  "naively",
  "nally",
  "natively",
  "naturalistically",
  "neatly",
  "nomenclaturally",
  "noteworthily",
  "nouzilly",
  "nutritionally",
  "objectively",
  "observationally",
  "oceanographically",
  "ontogenetically",
  "ontogenically",
  "ophthalmoscopically",
  "optically",
  "orly",
  "osmotically",
  "outstandingly",
  "pathohistologically",
  "pathomorphologically",
  "perceptually",
  "perinatally",
  "perioperaively",
  "peroperativly",
  "perplexingly",
  "pertinently",
  "pharmacokinetically",
  "phenomenologically",
  "philly",
  "philosophically",
  "phongsaly",
  "phylogenitically",
  "phylogentically",
  "phytochemically",
  "pivotally",
  "plausibly",
  "positionally",
  "postauricularly",
  "postsurgically",
  "pragmatically",
  "preauricularly",
  "preferentially",
  "premenstrually",
  "problematically",
  "prominently",
  "promisingly",
  "proportionately",
  "provisionally",
  "proximately",
  "prudently",
  "quickly",
  "rahilly",
  "rationally",
  "really",
  "reassembly",
  "recurrently",
  "renomegaly",
  "repressingly",
  "resultantly",
  "resultspreviously",
  "revealingly",
  "rheologically",
  "rhetorically",
  "scilly",
  "seemingly",
  "selectively",
  "semiannually",
  "sequently",
  "shortly",
  "simulteneously",
  "socially",
  "socioeconomically",
  "spectacularly",
  "spectroscopically",
  "startlingly",
  "steadily",
  "strangely",
  "subcellularly",
  "substantially",
  "substantively",
  "suggestively",
  "summatively",
  "superiorly",
  "supply",
  "surely",
  "synchronously",
  "syntactically",
  "synthetically",
  "technologically",
  "temporarily",
  "thermodynamically",
  "thoracically",
  "tinctorially",
  "transmurally",
  "tribally",
  "trivially",
  "ultrascructurally",
  "ultrasonically",
  "ultrastructually",
  "undeniably",
  "undesirably",
  "unequivocally",
  "unexplainably",
  "unfortunatly",
  "unintentionally",
  "univariably",
  "universally",
  "unknowingly",
  "unquestionably",
  "untypically",
  "utrastructurally",
  "wailly",
  "weekly",
  "wessely",
  "whitely",
  "willy",
  "worrisomely"
];

//You <sense> a <adj> <noun>. You feel <adj>.
export function randomDescription() {
  let randomSense = senses[Math.floor(Math.random() * senses.length)];
  let randomAdjective1 =
    adjectives[Math.floor(Math.random() * adjectives.length)];
  let randomAdjective2 =
    adjectives[Math.floor(Math.random() * adjectives.length)];
  let randomNoun = nouns[Math.floor(Math.random() * nouns.length)];

  let randomAdverb = adverbs[Math.floor(Math.random() * adverbs.length)];

  let article = "a";
  if (["a", "e", "i", "o", "u"].includes(randomAdjective1.slice(0, 1))) {
    article = "an";
  }

  return `You ${randomAdverb} ${randomSense} ${article} ${randomAdjective1} ${randomNoun}, which makes you feel ${randomAdjective2}.`;
}
